import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.min.css'
//
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
Vue.use(CoolLightBox)
//
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import vuetify from './plugins/vuetify';

let dotenv = require('dotenv');
dotenv.config();

Vue.config.productionTip = false

let handleOutsideClick
Vue.directive('closable', {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      try {
        e.stopPropagation()
        // Get the handler method name and the exclude array
        // from the object used in v-closable
        const { handler, exclude } = binding.value
        // This variable indicates if the clicked element is excluded
        let clickedOnExcludedEl = false
        // exclude.forEach(refName => {
        //   // We only run this code if we haven't detected
        //   // any excluded element yet

        //   if (!clickedOnExcludedEl) {
        //     // Get the element using the reference name
        //     console.log(vnode.context.$refs)
        //     console.log(vnode.context.$refs[refName])
        // console.log(e)
        //     console.log(e.target._prevClass)
        //     console.log(e.target.parentElement._prevClass)
        //     const excludedEl = vnode.context.$refs[refName]
        //     // See if this excluded elementz
        //     // is the same element the user just clicked on
        //     if (excludedEl !== undefined) {
        //       clickedOnExcludedEl = excludedEl.contains(e.target)
        //     }

        //   }
        // })

        if (e.target._prevClass === 'btn-react' || e.target.parentElement._prevClass === 'btn-react'
          || e.target._prevClass === 'btn-react-ed' || e.target.parentElement._prevClass === 'btn-react-ed') {
          clickedOnExcludedEl = true
        }

        // We check to see if the clicked element is not
        // the dialog element and not excluded
        if (!el.contains(e.target) && !clickedOnExcludedEl) {
          // If the clicked element is outside the dialog
          // and not the button, then call the outside-click handler
          // from the same component this directive is used in
          vnode.context[handler]()
        }
      } catch (e) {

      }

    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
